<div class="candidate-cv__sidebar">
  <div class="candidate-cv__sidebar-content">
    @if (contactsInfoMap?.size) {
      <div class="contacts">
        <h4 class="section-title">Contacts</h4>
        @for (infoItem of contactsInfoMap | keyvalue; track infoItem) {
          <div class="contacts">
            @if (infoItem.value) {
              <h6 class="section-sm-title contacts__title no-splittable-block">
                {{ infoItem.value.contactUniversalTitle | translate }}:
              </h6>
              @for (contact of infoItem.value.values; track contact) {
                <span class="contacts__item no-splittable-block">
                  {{ contact.value }}
                </span>
              }
            }
          </div>
        }
      </div>
    }
    @if (links?.length) {
      <div class="contacts long">
        <h4 class="section-title no-splittable-block">Links</h4>
        @for (link of links; track link) {
          <a
            class="link contacts__item no-splittable-block"
            [href]="link.value | encodeUrl"
            target="_blank">
            {{ link.value | decodeUrl }}
          </a>
        }
      </div>
    }
  </div>

  <div class="footer footer__sidebar"></div>
</div>
